import { Entity, Field } from "typegraph";

@Entity({one: "programProgress", many: "programProgressList"})
export default class ProgramProgress {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public completed: number;

	@Field()
	public total: number;

}



// WEBPACK FOOTER //
// ./src/panels/tracksProgram/entities/ProgramProgress.ts